import { unref } from 'vue';
import { moveFocusElement } from '~/utils/accessibility/navigation';

export const useSearchModalInput = ({ suggestionsEl = null, historyEl = null } = {}) => {
  function onKeydownArrowDown() {
    const sEl = unref(suggestionsEl);
    const hEl = unref(historyEl);

    const activeElement = sEl?.listEl || hEl?.listEl;

    if (!activeElement) {
      return;
    }

    moveFocusElement(activeElement, 'next');
  }

  return {
    onKeydownArrowDown,
  };
};

export default useSearchModalInput;
